import React from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation';

import type { Section } from '../../../models';
import { CERTIFICATE_OF_INSPECTION } from '../../../constants';
import YesAndNo from '../../../../shared/components/Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function CertificateOfInspection({ section, setSectionValues }: Props) {
  function onNoCertificateOfInspection(): void {
    setSectionValues({
      [CERTIFICATE_OF_INSPECTION.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesCertificateOfInspection(): void {
    setSectionValues({
      [CERTIFICATE_OF_INSPECTION.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Do you have a certificate of inspection for the property?</Label>}
      control={
        <YesAndNo
          yesHandler={onYesCertificateOfInspection}
          noHandler={onNoCertificateOfInspection}
          yesActive={section.getFieldValue(CERTIFICATE_OF_INSPECTION.FIELD_NAME.IS_ENABLED)}
        />
      }
      description={
        <FormHelp>
          You must provide copies of the reports before the lease is signed by tenant; later on, you will have the
          ability to attach any reports to your lease
        </FormHelp>
      }
    />
  );
}

CertificateOfInspection.description = 'Asks whether or not the property is subject to certificate of inspection';

export default CertificateOfInspection;
